module.exports = __webpack_public_path__ + "static/img/banner.1db6b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/banner.png
// module id = 574
// module chunks = 4